import "./AlertsList.css";
import { NoticeBox, AlertTriangle } from "../../../ui";

export default function AlertsList({ alerts = [] }) {
  if (!alerts.length) return null;

  return (
    <div className="lud-alerts">
      {alerts.map((alert, index) => (
        <NoticeBox
          key={index}
          variant={alert.level === "danger" ? "danger" : "warning"}
          icon={AlertTriangle}
          title={alert.text}
        >
          {alert.when}
        </NoticeBox>
      ))}
    </div>
  );
}